import React from "react";
import ServiceIllustration from "../../ServiceIllustration";
import { guides } from "./data";
import { Page, Inner, Header, Eyebrow, Grid, GuideCard, Article, Answer, Example, Actions, Action, ContactBox, Detail, Back, Preview, Resources } from "./styled";

export { guides } from "./data";

const guidePath = (guide) => `/przed-decyzja/${guide.slug}`;
const Cards = ({ items }) => <Grid>{items.map((guide) => (
  <GuideCard key={guide.slug} href={guidePath(guide)}>
    <ServiceIllustration type={guide.icon} />
    <h3>{guide.title}</h3><p>{guide.description}</p><span>Przeczytaj wskazówki →</span>
  </GuideCard>
))}</Grid>;

export default function DecisionGuides() {
  return <Page><Inner>
    <Header><Eyebrow>Praktyczne wskazówki</Eyebrow><h1>Przed decyzją</h1>
      <p>Zanim wpłacisz pieniądze, podpiszesz umowę lub zmienisz kredyt, sprawdź, co ma znaczenie w Twojej sytuacji. Znajdziesz tu krótkie odpowiedzi, przykłady i kroki, które możesz wykonać samodzielnie.</p>
    </Header>
    <nav aria-label="Wybierz temat wskazówek" style={{display:"flex",flexWrap:"wrap",gap:10,marginBottom:28}}>{[["podstawy","Podstawy kredytu"],["zakup","Zakup mieszkania"],["budowa","Budowa domu"],["zmiana","Mam już kredyt"]].map(([id,label])=><Action key={id} href={`#${id}`}>{label}</Action>)}</nav>
    <div id="podstawy" style={{scrollMarginTop:110}}><h2>Kredyt prostym językiem</h2><p>Najpierw poznaj podstawy. Bez bankowego żargonu.</p>
    <Cards items={guides.filter(guide => guide.group === "basics")} /></div>
    <div id="zakup" style={{scrollMarginTop:110,marginTop:32}}><h2>Kupuję mieszkanie</h2><p>Wkład, zadatek i terminy zakupu.</p><Cards items={guides.filter(guide => ["zakup-wtorny","zakup-deweloper","rkm"].includes(guide.topic) && guide.group !== "basics")} /></div>
    <div id="budowa" style={{scrollMarginTop:110,marginTop:32}}><h2>Buduję dom</h2><p>Budżet, etapy i wypłaty pieniędzy na budowę.</p><Cards items={guides.filter(guide => guide.topic === "budowa")} /></div>
    <div id="zmiana" style={{scrollMarginTop:110,marginTop:32}}><h2>Mam już kredyt</h2><p>Sprawdź, czy zmiana warunków pasuje do Twojego planu spłaty.</p><Cards items={guides.filter(guide => guide.topic === "refinansowanie")} /></div>
    <div style={{marginTop:32}}><h2>Inne cele finansowania</h2><Cards items={guides.filter(guide => guide.topic === "pozyczka-hipoteczna")} /></div>
    <Actions><Action href="/narzedzia/">Zobacz kalkulatory i dokumenty →</Action></Actions>
  </Inner></Page>;
}

export function GuidePreview() {
  return <Preview id="przed-decyzja"><Inner>
    <Eyebrow>Praktyczne wskazówki</Eyebrow><h2>Przed decyzją</h2>
    <p>Co sprawdzić przed wpłatą pieniędzy, jak zaplanować budowę i kiedy przeniesienie kredytu ma sens? Zacznij od pytania, które dotyczy Twojego planu.</p>
    <Cards items={[guides[0], guides[2], guides[4]]} />
    <Actions><Action href="/przed-decyzja">Zobacz wszystkie tematy →</Action></Actions>
  </Inner></Preview>;
}

export function DecisionGuide({ guide }) {
  const item = typeof guide === "string" ? guides.find((entry) => entry.slug === guide) : guide;
  if (!item) return <Page><Inner><Header><h1>Nie znaleźliśmy tego tematu</h1><p>Wybierz wskazówki dotyczące Twojego planu.</p></Header><Action href="/przed-decyzja">Przejdź do tematów →</Action></Inner></Page>;
  const contact = `/?source=formularz&topic=${encodeURIComponent(item.topic)}`;
  return <Page><Inner>
    <Back href="/przed-decyzja">← Wszystkie tematy</Back>
    <Header><Eyebrow>Przed decyzją</Eyebrow><h1>{item.title}</h1><p>{item.description}</p></Header>
    <Article>
      <Answer><p>{item.answer}</p></Answer>
      {item.sections.map((section) => <section key={section.title}>
        <h2>{section.title}</h2><p>{section.text}</p><ul>{section.items.map((text) => <li key={text}>{text}</li>)}</ul>
      </section>)}
      <Example><Eyebrow>Przykład edukacyjny</Eyebrow><h2>{item.example.title}</h2><p>{item.example.text}</p>{item.example.rows && <dl>{item.example.rows.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>}{item.example.takeaway && <p><strong>Co z tego wynika?</strong> {item.example.takeaway}</p>}</Example>
      <Resources><h2>Przygotuj się samodzielnie</h2><p>Skorzystaj z narzędzia lub listy dokumentów, aby uporządkować podstawowe informacje przed rozmową.</p>
        <Actions>{item.tools.map((tool, index) => <Action $primary={index === 0} key={tool.href} href={tool.href} target="_blank" rel="noopener noreferrer">{tool.label} ↗</Action>)}</Actions>
      </Resources>
      <ContactBox><h2>{item.cta}</h2><p>{item.help}</p><p><strong>Co przygotować?</strong> {item.prepare}</p>
        <p>Rozmowa i obsługa kredytowa nie wiążą się dla klienta z dodatkową opłatą. Wynagrodzenie otrzymujemy od banku po uruchomieniu kredytu.</p>
        <Actions><Action $primary href={contact}>{item.contactLabel || "Umów rozmowę o swoim planie"} →</Action></Actions>
      </ContactBox>
      <section><h2>Najczęstsze pytania</h2>{item.faqs.map((faq) => <Detail key={faq.q}><summary>{faq.q}</summary><p>{faq.a}</p></Detail>)}</section>
    </Article>
  </Inner></Page>;
}
